import React, { useState } from "react";
import templeOverlay from "../assets/temple-overlay.png";
import MobileNavbar from "../components/MobileNavbar";

// IMPORT YOUR GALLERY IMAGES
import IMG_1 from "../assets/1.jpg";
import IMG_2 from "../assets/2.jpg";
import IMG_3 from "../assets/3.jpg";
import IMG_4 from "../assets/4.jpg";
import IMG_5 from "../assets/5.jpg";
import IMG_6 from "../assets/6.JPG";
import IMG_11 from "../assets/11.jpg";
import IMG_7 from "../assets/7.JPG";
import IMG_8 from "../assets/8.JPG";
import IMG_9 from "../assets/9.JPG";
import IMG_10 from "../assets/10.JPG";

const palette = {
  bg: "#FFF8F0",
  ink: "#241B18",
  sub: "#5B4B45",
  gold: "#D9A441",
  railLine: "#E4CFAF",
  blush: "#FFF1E3",
};

export default function Gallery() {
  // All gallery images in one array
  const galleryImages = [
    IMG_1,
    IMG_2,
    IMG_3,
    IMG_4,
    IMG_5,
    IMG_6,
    IMG_7,
    IMG_8,
    IMG_9,
    IMG_10,
    IMG_11,
  ];

  // When not null, this holds the image currently opened in popup
  const [selectedImage, setSelectedImage] = useState(null);
  const [zoom, setZoom] = useState(1); // 1 = 100%

  const openImage = (img) => {
    setSelectedImage(img);
    setZoom(1); // reset zoom every time you open an image
  };

  const closeModal = () => {
    setSelectedImage(null);
    setZoom(1);
  };

  const handleZoomIn = () => {
    setZoom((z) => Math.min(z + 0.25, 4)); // max 4x
  };

  const handleZoomOut = () => {
    setZoom((z) => Math.max(z - 0.25, 1)); // min 1x
  };

  const handleZoomReset = () => {
    setZoom(1);
  };

  const handleWheel = (e) => {
    // optional: ctrl+scroll or just scroll to zoom
    if (e.ctrlKey) {
      e.preventDefault();
      const delta = e.deltaY;
      setZoom((z) => {
        const next = z + (delta < 0 ? 0.1 : -0.1);
        return Math.min(4, Math.max(1, next));
      });
    }
  };

  return (
    <div className="relative min-h-screen">
      {/* MOBILE NAVBAR */}
      <MobileNavbar />
      {/* BACKGROUND OVERLAY (faint, behind everything) */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: palette.bg,
          backgroundImage: `url(${templeOverlay})`,
          backgroundSize: "cover", // full-page background
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          opacity: 0.18, // ONLY background is faded
          mixBlendMode: "overlay",
          zIndex: 0,
        }}
      />

      {/* MAIN CONTENT (full brightness) */}
      <div
        className="relative z-10 py-16 px-6 min-h-screen"
        style={{ color: palette.ink }}
      >
        <div className="mx-auto max-w-6xl">
          {/* Heading */}
          <section className="text-center">
            <h1
              className="text-3xl font-bold text-sapphire mb-6"
              style={{
                fontFamily: '"Playfair Display", serif',
                color: palette.sub,
              }}
            >
              A glimpse into the Carnatic Café ambience — culture, colours,
              décor, memories.
            </h1>
          </section>

          {/* ===== Gallery Grid ===== */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-10">
            {galleryImages.map((img, index) => (
              <button
                key={index}
                type="button"
                onClick={() => openImage(img)}
                className="rounded-2xl bg-white shadow-lg overflow-hidden border focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                style={{ borderColor: palette.railLine }}
              >
                <div
                  className="h-44 md:h-56 bg-center bg-cover"
                  style={{
                    backgroundImage: `url(${img})`,
                  }}
                ></div>
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ===== IMAGE POPUP / LIGHTBOX ===== */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/75"
          onClick={closeModal} // click outside to close
        >
          {/* Stop click from bubbling when clicking on image/card */}
          <div
            className="relative max-w-5xl max-h-[90vh] mx-4 bg-black rounded-2xl overflow-hidden shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              type="button"
              onClick={closeModal}
              className="absolute top-3 right-3 z-20 rounded-full bg-black/60 text-white w-8 h-8 flex items-center justify-center text-lg font-bold hover:bg-black/80"
              aria-label="Close image"
            >
              ×
            </button>

            {/* Zoom controls */}
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2 bg-black/60 text-white rounded-full px-3 py-1 text-sm">
              <button
                type="button"
                onClick={handleZoomOut}
                className="px-2 py-1 rounded-full hover:bg-black/80"
              >
                −
              </button>
              <span className="px-2">
                {Math.round(zoom * 100)}%
              </span>
              <button
                type="button"
                onClick={handleZoomIn}
                className="px-2 py-1 rounded-full hover:bg-black/80"
              >
                +
              </button>
              <button
                type="button"
                onClick={handleZoomReset}
                className="ml-1 px-2 py-1 rounded-full hover:bg-black/80"
              >
                Reset
              </button>
            </div>

            {/* Large image with zoom & scroll */}
            <div
              className="flex items-center justify-center max-h-[90vh] max-w-[90vw] overflow-auto"
              onWheel={handleWheel}
            >
              <img
                src={selectedImage}
                alt="Carnatic Cafe gallery"
                className="block object-contain"
                style={{
                  transform: `scale(${zoom})`,
                  transformOrigin: "center center",
                  transition: "transform 0.2s ease-out",
                  maxHeight: "90vh",
                  maxWidth: "90vw",
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
